// extracted by mini-css-extract-plugin
export default {"pageWrap":"wc-z","fullWidth":"xc-z","heading":"yc-z","fullBleed":"zc-z","hidden":"Ac-z"};